module.exports = __webpack_public_path__ + "static/media/account-blue.39932189.svg";